import { useState, useContext } from "react";
import { Button, Form, Modal, Row, Col, ListGroup } from "react-bootstrap";
import "./prePrintedLabels.css";
import { useAppDispatch } from "../../../../store/hooks";
import { isValidCustomerARS } from "../../../../store/api/apiSlice";
import { StartReturnContext } from "../../../../context/StartReturnContext";

interface Props {
    accountid: string;
    show: boolean;
    handleClose: () => void;
    onError: (errorMessage: string) => void;
}

function PrePrintedLabelsModal({
    accountid,
    show,
    handleClose,
    onError,
}: Props) {
    const [inputValue, setInputValue] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useAppDispatch();
    const { arsTracking, setArsTracking } = useContext(StartReturnContext);

    const handleModalClose = () => {
        setInputValue("");
        setErrorMessage("");
        handleClose();
    };

    const handleAddItem = () => {
        setErrorMessage("");
        const trimmed = inputValue.trim();
        if (trimmed === "") return;

        const isDuplicate = arsTracking.some(
            (item) => item.CUSTRECORD_ARS_TRACKING_NUMBER === trimmed
        );

        if (isDuplicate) {
            setErrorMessage("Item already exists in the list.");
            return;
        }

        try {
            dispatch(isValidCustomerARS({
                CUSTRECORD_ARS_TRACKING_NUMBER: trimmed,
                CUSTRECORD_ARS_CUSTOMER: String(accountid),
            })).then((result: any) => {
                if (
                    !result?.payload?.data ||
                    !result?.payload?.data.ID ||
                    !result?.payload?.data.CUSTRECORD_ARS_TRACKING_NUMBER
                ) {
                    setErrorMessage("Shipping label scanned is not a valid Pharma Logistics label for this account, please add another one or choose to print/request one.");
                }
                else {

                    const { ID, CUSTRECORD_ARS_TRACKING_NUMBER } = result?.payload?.data;
                    setArsTracking([
                        ...arsTracking,
                        { ID: String(ID), CUSTRECORD_ARS_TRACKING_NUMBER: CUSTRECORD_ARS_TRACKING_NUMBER },
                    ]);
                    setInputValue("");
                    onError("");

                }
            });
        } catch (error) { }
    };

    const handleDeleteItem = (id: string) => {
        setArsTracking(arsTracking.filter((item) => item.ID !== id));
    };
    return (

        <Modal
            show={show}
            centered={true}
            dialogClassName="modal-60w"
            className="custom_modal fixed-height-modal"
            onHide={handleModalClose}
        >
            <Modal.Header className="custom_modal_header">
                <Modal.Title className="custom_modal_header_title">
                    <div className="custom_modal_header_title_left">Pre-printed Labels</div>
                    <div className="custom_modal_header_title_right">
                        <Button variant="link" onClick={handleModalClose}>
                            <i className="fa-solid fa-times"></i>
                        </Button>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="custom_modal_body d-flex flex-column" >
                <p>
                    Scan or type in a preprinted label(s)
                </p>
                <Form className="form_box d-flex flex-column flex-grow-1">
                    <Row className="align-items-center">
                        <Col xs={8}>
                            <Form.Group controlId="itemInput">
                                <Form.Control
                                    type="text"
                                    placeholder="Enter item"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            handleAddItem();
                                        }
                                    }}
                                />
                                {errorMessage && (
                                    <p className="error-validation">{errorMessage}</p>
                                )}
                            </Form.Group>
                        </Col>
                        <Col xs={4}>
                            <Button variant="primary" onClick={handleAddItem}>
                                Add
                            </Button>
                        </Col>
                    </Row>

                    <ListGroup className="mt-3 scrollableList">
                        {arsTracking.map((item) => (
                            <ListGroup.Item
                                key={item.ID}
                                className="d-flex justify-content-between align-items-center"
                            >
                                {item.CUSTRECORD_ARS_TRACKING_NUMBER}
                                <Button
                                    variant="link"
                                    style={{ color: "grey", textDecoration: "none" }}
                                    size="sm"
                                    onClick={() => handleDeleteItem(item.ID)}
                                >
                                    <i className="fa fa-trash"></i>
                                </Button>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>

                    <div className="d-flex justify-content-center mt-auto pt-3">
                        <Button variant="primary" onClick={handleModalClose}>
                            Done
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};


export default PrePrintedLabelsModal;